// El link de la marca: lo que pega la persona en el primer paso del onboarding de marca
// (ADR-2026-09-28-onboarding-v2-etapa-1). Todo puro: se usa mientras tipea, para mostrar
// qué detectamos, y al enviar, para mandarle al backend una URL armada.

export type Plataforma = 'tiendanube' | 'shopify' | 'instagram' | 'web';

/** Lo pegado, llevado a una URL con esquema. null si no parece un dominio. */
export function normalizarLink(raw: string): string | null {
  const limpio = raw.trim().replace(/\s+/g, '');
  if (!limpio || limpio.startsWith('@')) return null;
  const conEsquema = /^https?:\/\//i.test(limpio) ? limpio : `https://${limpio}`;
  try {
    const url = new URL(conEsquema);
    const host = url.hostname;
    // Un dominio tiene al menos un punto y un TLD de 2+ letras.
    if (!/\.[a-z]{2,}$/i.test(host)) return null;
    return url.href;
  } catch {
    return null;
  }
}

/** El dominio, sin `www.`, para los textos ("Entrando a vcp.com.ar"). */
export function dominioDe(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./i, '');
  } catch {
    return url;
  }
}

/**
 * Qué parece ser lo que pegó, sólo por el texto. Es una pista para la interfaz: un
 * dominio propio de Shopify o Tiendanube recién se sabe al analizarlo.
 */
export function detectarPlataforma(raw: string): Plataforma | null {
  const t = raw.trim().toLowerCase();
  if (!t) return null;
  if (t.startsWith('@') || /(^|\/\/|\.)instagram\.com/.test(t)) return 'instagram';
  const url = normalizarLink(raw);
  if (!url) return null;
  const host = new URL(url).hostname.toLowerCase();
  if (host.endsWith('mitiendanube.com') || host.endsWith('tiendanube.com')) return 'tiendanube';
  if (host.endsWith('myshopify.com')) return 'shopify';
  return 'web';
}

export const ETIQUETA_DE_PLATAFORMA: Record<Plataforma, string> = {
  tiendanube: 'Tienda en Tiendanube',
  shopify: 'Tienda en Shopify',
  instagram: 'Instagram',
  web: 'Sitio web',
};
